import ContainerSimple from "../../../Components/ContainerSimple";
import InputAdmin from "../../../Components/InputFields/InputAdmin";
import Custom from "../../../Components/Buttons/Custom";
import MultipleSelectAdmin from "../../../Components/InputFields/MultipleSelectAdmin";

export default function CreateTransactionModal({ onClose }) {
  return (
    <ContainerSimple>
      <div className="w-full flex gap-12">
        <InputAdmin
          label="نوع تراکنش"
          id="type"
          name="type"
          type="select"
          selectOptions={["واریز", "برداشت"]}
          selectPlaceHolder="انتخاب کنید"
        />
        <InputAdmin
          label="تاریخ تراکنش"
          id="type"
          name="type"
          type="datetime-local"
        />
      </div>
      <div className="w-full flex gap-12">
        <InputAdmin label="مبلغ تراکنش" id="type" name="type" type="number" />
        <InputAdmin
          label="کد پیگیری بلاکچین"
          id="type"
          name="type"
          type="text"
        />
      </div>
      <div className="w-full flex gap-12">
        <InputAdmin label="آدرس مبدأ" id="type" name="type" type="text" />
        <InputAdmin label="آدرس مقصد" id="type" name="type" type="text" />
      </div>
      <div className="w-full flex gap-12">
        <InputAdmin
          label="نوع چالش"
          id="type"
          name="type"
          type="select"
          selectOptions={["واقعی", "دمو"]}
          selectPlaceHolder="انتخاب کنید"
        />
        <InputAdmin
          label="دسته چالش"
          id="type"
          name="type"
          type="select"
          selectOptions={["۲ فاز عادی", "۱ فاز عادی"]}
          selectPlaceHolder="انتخاب کنید"
        />
      </div>
      <div className="w-full flex gap-12">
        <InputAdmin
          label="نام چالش"
          id="type"
          name="type"
          type="select"
          selectOptions={["چالش ۱۰ کا", "چالش ۲۰ کا"]}
          selectPlaceHolder="انتخاب کنید"
        />
        <InputAdmin
          label="نوع فاز"
          id="type"
          name="type"
          type="select"
          selectOptions={["فاز ۱", "فاز ۲", "فاندد"]}
          selectPlaceHolder="انتخاب کنید"
        />
      </div>
      <MultipleSelectAdmin
        header="انتخاب کاربر"
        search={false}
        footer="کاربر انتخاب شده"
        footerValue="امین شکرالهی (168291)"
        tableColumns={[
          { key: "code", label: "کد" },
          { key: "name", label: "نام" },
        ]}
        tableData={[
          { code: "168291", name: "امین شکرالهی" },
          { code: "168291", name: "امین شکرالهی" },
          { code: "168291", name: "امین شکرالهی" },
          { code: "168291", name: "امین شکرالهی" },
          { code: "168291", name: "امین شکرالهی" },
          { code: "168291", name: "امین شکرالهی" },
          { code: "168291", name: "امین شکرالهی" },
          { code: "168291", name: "امین شکرالهی" },
        ]}
      />
      <Custom
        text="ثبت دستی تراکنش"
        svg_name="add"
        svgClassName="stroke-zi-text-dark"
        href=""
        className="!rounded-lg !p-2.5 text-zi-text-dark mt-6 bg-zi-gradient-button-blue"
        textShadow={true}
        svgShadow={true}
        onClick={onClose}
      />
    </ContainerSimple>
  );
}
